import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Link as RouterLink } from 'react-router-dom';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import CardActionArea from '@material-ui/core/CardActionArea';

import SecurityOutlinedIcon from '@material-ui/icons/SecurityOutlined';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles(theme => ({
    actionArea: {
        display: 'block',
        height: '100%',
        borderRadius: 16,
        transition: 'all 0.15s ease',
        '&:hover': {
            boxShadow: '0 4px 12px rgba(63, 81, 181, 0.12)',
            transform: 'translateY(-2px)'
        }
    },
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 16,
        border: '1px solid #E5E7EB',
        boxShadow: '0 1px 3px rgba(16, 24, 40, 0.06)'
    },
    content: {
        flex: 1,
        padding: theme.spacing(3)
    },
    headerRow: {
        marginBottom: theme.spacing(2)
    },
    title: {
        fontWeight: 700,
        fontSize: '1.05rem',
        color: '#111827'
    },
    icon: {
        width: 44,
        height: 44,
        minWidth: 44,
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(63, 81, 181, 0.1)',
        color: '#3f51b5'
    },
    bodyText: {
        color: '#6B7280'
    },
    bodyRow: {
        marginTop: theme.spacing(0.5)
    },
    footer: {
        padding: theme.spacing(1.5, 3),
        borderTop: '1px solid #EEF0F4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    footerLabel: {
        fontWeight: 600,
        color: '#3f51b5',
        fontSize: '0.9rem'
    },
    chevron: {
        color: '#3f51b5'
    }
}));

const Security = props => {
    const { className, data, ...rest } = props;

    const classes = useStyles();

    return (
        <CardActionArea
            component={RouterLink}
            to={'/settings/security'}
            className={classes.actionArea}>
            <Card {...rest} className={clsx(classes.root, className)}>
                <CardContent className={classes.content}>
                    <Grid
                        container
                        direction="row"
                        wrap="nowrap"
                        justify="space-between"
                        alignItems="flex-start"
                        className={classes.headerRow}>
                        <Grid item xs zeroMinWidth>
                            <Typography className={classes.title}>
                                Sécurité de l'application
                            </Typography>
                        </Grid>
                        <Grid item>
                            <div className={classes.icon}>
                                <SecurityOutlinedIcon fontSize="small" />
                            </div>
                        </Grid>
                    </Grid>

                    <Typography variant="body2" className={classes.bodyText}>
                        Temps d'inactivité avant déconnexion :{' '}
                        <strong>
                            {data.maxConnectionTime == '0'
                                ? 'Illimité'
                                : `${data.maxConnectionTime}H`}
                        </strong>
                    </Typography>
                    <Typography variant="body2" className={clsx(classes.bodyText, classes.bodyRow)}>
                        Sécurité minimale des mots de passe :{' '}
                        <strong>{data.strenghtPassword}</strong>
                    </Typography>
                    <Typography variant="body2" className={clsx(classes.bodyText, classes.bodyRow)}>
                        Durée avant réinitialisation du mot de passe :{' '}
                        <strong>{data.resetPassword} jours</strong>
                    </Typography>
                </CardContent>

                <div className={classes.footer}>
                    <Typography className={classes.footerLabel}>Configurer la sécurité</Typography>
                    <ChevronRightIcon fontSize="small" className={classes.chevron} />
                </div>
            </Card>
        </CardActionArea>
    );
};

export default Security;
